import client from './api/client';

export const paymentPolling = async (sessionId: string): Promise<void> => {
  const { data } = await client('auth').get(`checkout/sessions/${sessionId}`);
  return data;
};
